const listeners = new Set();

async function noopAsync() {
  return '';
}

export const DISABLED_CLERK_RUNTIME = {
  enabled: false,
  workspaceEnabled: false,
  adminEnabled: false,
  isLoaded: true,
  isSignedIn: false,
  user: null,
  getToken: noopAsync,
  signOut: noopAsync,
};

let currentRuntime = DISABLED_CLERK_RUNTIME;

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(currentRuntime);
    } catch (_error) {
      // Keep runtime updates isolated from listener failures.
    }
  });
}

export function getClerkRuntime() {
  return currentRuntime;
}

export function setClerkRuntime(nextRuntime) {
  currentRuntime = nextRuntime || DISABLED_CLERK_RUNTIME;
  notify();
}

export function subscribeClerkRuntime(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
